export interface Device {
  type: string;
  id: string;
  displayName?: string | null;
  deviceDbId?: number | null;
}

export interface Station {
  id: string;
  name: string;
  orgName?: string;
  color: string;
  devices: Device[];
}

export const DEVICE_TYPE_COLORS: Record<string, string> = {
  pump: '#22c55e',
  pump_d: '#16a34a',
  pump_b: '#4ade80',
  powermeter: '#f59e0b',
  sensor: '#06b6d4',
  heartbeat: '#ef4444',
  adder: '#f97316',
  mixer_b: '#ec4899',
};

export const DEVICE_TYPE_LABELS: Record<string, string> = {
  pump: 'Pump',
  pump_d: 'Pump-D',
  pump_b: 'Pump-B',
  powermeter: 'Power',
  sensor: 'Sensor',
  heartbeat: 'HB',
  adder: 'Adder',
  mixer_b: 'Mixer',
};

export const DEVICE_ICONS: Record<string, string> = {
  pump: '⚡',
  pump_d: '⚡',
  pump_b: '⚡',
  powermeter: '📊',
  sensor: '📡',
  heartbeat: '💓',
  adder: '➕',
  mixer_b: '🔄',
  mixer: '🔄',
  floating_ball: '🔵',
};

const CDN = 'https://cdn-qualitybrain.s3.ap-southeast-1.amazonaws.com/limbic/library/batch';

// Real UUIDs lifted from the live object-library response so every device type
// has an image even when the runtime maker fetch fails — no emoji, no flicker.
export const DEVICE_TYPE_IMAGES: Record<string, string> = {
  adder: `${CDN}/3a58ef75-c5ac-435c-95a0-a9c6ad086372.webp`,
  pump: `${CDN}/ebf172d7-5f11-4798-bf67-015c1cad4e8c.webp`,
  pump_b: `${CDN}/ebf172d7-5f11-4798-bf67-015c1cad4e8c.webp`,
  pump_d: `${CDN}/82230bfb-fd91-41c1-a1de-306d2807e60e.png`,
  mixer: `${CDN}/26c9ab38-cc69-4724-8a87-8d4074991276.webp`,
  mixer_b: `${CDN}/32fe9696-eb01-4b3c-9a4a-67835e604da6.webp`,
  floating_ball: `${CDN}/fcce066d-3f29-4e88-82e0-7e1783e74e50.webp`,
};

const STATION_FALLBACK_ICONS = ['🏭', '🏢', '🏗️', '🏛️', '🏥', '🧪', '🌐'];

const STATION_FALLBACK_COLORS = [
  '#06b6d4', '#a855f7', '#eab308', '#14b8a6', '#f43f5e', '#0ea5e9', '#84cc16',
];

function hashStringToIndex(value: string, modulo: number): number {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash) % modulo;
}

export function colorForStationId(stationId: string): string {
  const idx = hashStringToIndex(stationId, STATION_FALLBACK_COLORS.length);
  return STATION_FALLBACK_COLORS[idx];
}

export function iconForStationId(stationId: string): string {
  const idx = hashStringToIndex(stationId, STATION_FALLBACK_ICONS.length);
  return STATION_FALLBACK_ICONS[idx] ?? '🏭';
}
